import {
    REQUEST_STATE,

    CORE_GET_OIL_PRICE_REQUEST,
    CORE_GET_OIL_PRICE_SUCCESS,
    CORE_GET_OIL_PRICE_FAILURE,


} from '../types'

const requestState = REQUEST_STATE

export default {
    oilPrice: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_OIL_PRICE_REQUEST:
                return state
            case CORE_GET_OIL_PRICE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_OIL_PRICE_FAILURE:
                return []
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/oilPrice.js